let teamNamesDict = {};
teamNamesDict["South Alabama"] = "SA";
teamNamesDict["Western Michigan"] = "WM";
teamNamesDict["South Carolina State"] = "SCS"
teamNamesDict["Jackson State"] = "JS";
teamNamesDict["Memphis"] = "MEM";
teamNamesDict["West Virginia"] = "WV";
teamNamesDict["James Madison"] = "JM";
teamNamesDict["Western Kentucky"] = "WK";
teamNamesDict["UNLV"] = "UNLV";
teamNamesDict["Cal"] = "CAL";
teamNamesDict["Sam Houston"] = "SAM";
teamNamesDict["Georgia Southern"] = "GEO";
teamNamesDict["Ohio"] = "OHIO";
teamNamesDict["Jacksonville State"] = "JSTAT";
teamNamesDict["Florida"] = "FL";
teamNamesDict["Tulane"] = "TUL";
teamNamesDict["Indiana"] = "IU";
teamNamesDict["Notre Dame"] = "ND";
teamNamesDict["SMU"] = "SMU";
teamNamesDict["Penn State"] = "PENN";
teamNamesDict["Clemson"] = "CLEM";
teamNamesDict["Texas"] = "TEX";
teamNamesDict["Tennessee"] = "TEN";
teamNamesDict["Ohio State"] = "OSU";
teamNamesDict["Coastal Carolina"] = "CC";
teamNamesDict["UTSA"] = "UTSA";
teamNamesDict["Northern Illinois"] = "NI";
teamNamesDict["Fresno State"] = "FS";
teamNamesDict["South Florida"] = "SF";
teamNamesDict["San Jose State"] = "SJS";
teamNamesDict["Pitt"] = "PITT";
teamNamesDict["Toledo"] = "TOL";
teamNamesDict["Rutgers"] = "RUT";
teamNamesDict["Kansas State"] = "KS";
teamNamesDict["Arkansas State"] = "ARK ST";
teamNamesDict["Bowling Green"] = "BG";
teamNamesDict["Syracuse"] = "SY";
teamNamesDict["Washington State"] = "WS";
teamNamesDict["Georgia Tech"] = "GT";
teamNamesDict["Vanderbilt"] = "VAN";
teamNamesDict["Navy"] = "NAVY";
teamNamesDict["Oklahoma"] = "OU";
teamNamesDict["Arkansas"] = "ARK";
teamNamesDict["Texas Tech"] = "TT";
teamNamesDict["USC"] = "USC";
teamNamesDict["Texas A&M"] = "A&M";
teamNamesDict["UConn"] = "UCON";
teamNamesDict["North Carolina"] = "NC";
teamNamesDict["Boston College"] = "BC";
teamNamesDict["Nebraska"] = "NEB";
teamNamesDict["TCU"] = "TCU";
teamNamesDict["Louisiana"] = "LL";
teamNamesDict["Miami"] = "MIA";
teamNamesDict["Iowa State"] = "IS";
teamNamesDict["Colorado State"] = "CS";
teamNamesDict["Miami (Ohio)"] = "MIO";
teamNamesDict["NC State"] = "NCS";
teamNamesDict["East Carolina"] = "EC";
teamNamesDict["BYU"] = "BYU";
teamNamesDict["Colorado"] = "COL";
teamNamesDict["Army"] = "ARMY";
teamNamesDict["Marshall"] = "MAR";
teamNamesDict["Missouri"] = "MIZ";
teamNamesDict["Iowa"] = "IOWA";
teamNamesDict["Alabama"] = "BAMA";
teamNamesDict["Michigan"] = "MICH";
teamNamesDict["Louisville"] = "LOU";
teamNamesDict["Washington"] = "WASH";
teamNamesDict["South Carolina"] = "SC";
teamNamesDict["Illinois"] = "IL";
teamNamesDict["LSU"] = "LSU";
teamNamesDict["Baylor"] = "BAY";
teamNamesDict["Ole Miss"] = "OLE";	
teamNamesDict["Duke"] = "DUKE";
teamNamesDict["North Texas"] = "NT";
teamNamesDict["Texas State"] = "TS";
teamNamesDict["Minnesota"] = "MINN";
teamNamesDict["Virginia Tech"] = "VT";
teamNamesDict["Liberty"] = "LIB";
teamNamesDict["Buffalo"] = "BUF";

export default teamNamesDict;